import { Component, Input } from '@angular/core';
import moment from 'moment';
import { IExtendedControl } from '../models/IExtendedControl';

@Component({
    selector: 'app-property-information',
    templateUrl: './property-information.component.html',
    standalone: false,
})
export class PropertyInformationComponent {
    @Input() public property: IExtendedControl;

    constructor() {}

    public get relativeChangeTime(): string {
        var propertyTime = moment(this.property.propertyValueMetadata.changedAt);

        const currentDateTime = moment().utc();
        let relativeTime = '';
        if (currentDateTime.isBefore(propertyTime)) {
            relativeTime = propertyTime.from(propertyTime);
        } else {
            relativeTime = propertyTime.fromNow();
        }

        return relativeTime;
    }

    public get hasReportedValue() {
        return this.property.reportedValue != null && this.property.reportedValue !== 'NaN';
    }
}
